import * as HTTP_REQUEST from "./api";
import { handleResponse } from "../utils/functions";

const PATH_MODEL = "/credenciales";
const PATH_TEMPLATE_EXCEL = "/credenciales/plantilla";
const PATH_DATA_EXCEL = "/credenciales/download";

export const getAll = async () => {
  const response = await HTTP_REQUEST.get(PATH_MODEL);
  return handleResponse(response);
};

// Obtiene el excel platilla
export const downloadExcelPlantillaBDParticipantes = async () => {
  const response = await HTTP_REQUEST.getFile(PATH_TEMPLATE_EXCEL);
  return response; // return a blob
};

// Obtiene el excel file
export const downloadExcelFileBDCredenciales = async () => {
  const response = await HTTP_REQUEST.getFile(PATH_DATA_EXCEL);
  return response; // return a blob
};
